// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AlertError from "@ces/XDL/Icons/AlertError";
import AlertInfo from "@ces/XDL/Icons/AlertInfo";
import AlertSuccess from "@ces/XDL/Icons/AlertSuccess";
import AlertWarning from "@ces/XDL/Icons/AlertWarning";
import Close from "@ces/XDL/Icons/Close";
import { buttonTransparent } from "@ces/XDL/PreStyle/button";
import { xBaseTheme } from "@ces/XDL/types";
import { color, xScreen } from "@ces/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css, ThemeProps } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        closeButtonProps: {
            mergeCss: true,
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                position: absolute;
                top: 0;
                right: 0;
                border: 0;
                padding: 12px 12px 8px 12px;

                ${buttonTransparent}
                ${IconWrapper} {
                    color: ${color("text.link")};
                    &:hover {
                        color: ${color("text.link", 0.33)};
                    }
                }
                &:hover {
                    ${IconWrapper} {
                        color: ${color("text.link", 0.33)};
                    }
                }
            `,
            size: 24,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            size: 14,
            color: "text.link",
            css: css`
                &:hover {
                    color: ${color("text.link", 0.33)};
                }
            `,
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-right: 12px;
            `,
        },
        iconSrcByMessage: {
            success: AlertSuccess,
            warning: AlertWarning,
            danger: AlertError,
            info: AlertInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                line-height: 22px;
                font-size: 14px;
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                border-radius: 2px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                @media print {
                    display: none;
                }
                ${xScreen("lte", "xs")} {
                    max-width: calc(100% - 30px);
                    margin: 0 15px;
                }
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                }
                align-items: center;
                padding: 12px 12px 8px 12px;
                font-size: 14px;
                a span {
                    font-size: 14px;
                }
                ${TypographyStyle} {
                    padding-right: 12px;
                    word-break: break-word;
                }
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
